<div class="container_iframe">
    <iframe src="https://www.gob.pe/institucion/munilambayeque/campa%C3%B1as?filter%5Bterms%5D=&amp;sheet=2" frameborder="0">
    </iframe>
</div>


